<template>
    <div class="itinerary ">
        <div class="mb-4">
            <booking-summary></booking-summary>
            <div class="mb-4">
                <current-action v-bind:action="'Set your itinerary'"
                                v-bind:summary="'Choose when you\'d like to enjoy your included extras'">
                </current-action>
            </div>

       
        </div>

        <div class="row room-itinerary-wrapper">


            <div v-bind:key="room.leg"
                 v-for="room in booking.legs"
                 class="col-lg-12  mb-4">

          

                <itinerary-options v-bind:value="room"></itinerary-options>

            </div>

        </div>




        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">

                        <button v-on:click="onBack" 
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>
                    <div class="col-12 justify-content-end d-flex">
                        <button class="btn btn--slate-blue btn--continue"
                                v-on:click="onContinue">
                            Next Step
                        </button>
                    </div>
                </div>

            </template>
        </actions-bar>

    </div>





</template>

<script>

    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import BookingSummary from '../components/BookingSummary.vue';
    import CurrentAction from '../components/CurrentAction.vue';
    import ItineraryOptions from '../components/ItineraryOptions.vue';

    import { store } from '../store/index';

    export default {
        name: 'StayItinerary',
        components: {
            ActionsBar,
            BookingSummary,
            CurrentAction,
            ItineraryOptions
        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            }
        },
        methods: {
            onContinue() {
                this.$router.push({ name: 'stay_addons', params: { id: this.session.Id } });
            },
            onBack() {
                this.$router.push({ name: 'stay_guests', params: { id: this.session.Id } });

             
            },
        }
    }
</script>

<style src="@/modules/stay/css/itinerary.css"></style>
